import { Outlet } from 'react-router-dom';
import { Logo } from '@/components/logo';

export function ConnectionLayout() {
  return (
    <div className="w-full min-h-[100vh] lg:grid lg:grid-cols-2">
      <div className="flex items-center justify-center py-12">
        <Outlet />
      </div>
      <div className="relative hidden h-full flex-col bg-muted p-10 lg:flex">
        <div className="relative z-20 flex items-center text-lg font-medium gap-3">
          <Logo />
          Itelligent
        </div>
      </div>
    </div>
  );
}
